import React from "react";
import classNames from "classnames";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { PagedResources } from "@common/pagedResources";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { Resource } from "./resource";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

// The authors are every planzone resource, searched and paginated by the back.
function ResourcesFilter({
  selectedResources,
  selectResource,
  unSelectResource,
}: Props) {
  const { t } = useTranslation();

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.resourcesFilter, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            {selectedResources.length > 0 ? (
              <p className={styles.selectedResourcesNames}>
                {selectedResources.map((resource, index) => (
                  <span key={resource.uuid}>
                    {resource.name}
                    {index !== selectedResources.length - 1 ? ", " : ""}
                  </span>
                ))}
              </p>
            ) : (
              <p className={styles.selectedResourcesNames}>
                {t("documentsPage.reportsPage.filters.all")}
              </p>
            )}
            <ToggleArrow className={styles.toggleArrow} />
          </div>
          {isVisible && (
            <PagedResources
              flagName="reportsAuthorsFlag"
              className={styles.list}
            >
              {(resources) =>
                resources.map((resource) => {
                  const isSelected = !!selectedResources.find(
                    ({ uuid }) => uuid === resource.uuid,
                  );

                  return (
                    <div
                      key={resource.uuid}
                      className={styles.item}
                      onClick={() =>
                        isSelected
                          ? unSelectResource(resource)
                          : selectResource(resource)
                      }
                    >
                      <Resource resource={resource} isSelected={isSelected} />
                    </div>
                  );
                })
              }
            </PagedResources>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { ResourcesFilter };
